import type { BoxProps, ImageProps } from "@chakra-ui/react";

const imageStyles: ImageProps = {
  w: "full",
  borderRadius: "xl",
  objectFit: { md: "scale-down", lg: "cover" },
};

const boxStyles: BoxProps = {
  pos: "absolute",
  maxWidth: "372px",
  top: { base: "90%", lg: "75%" },
};

export { imageStyles, boxStyles };
